export default {
  appName: "Brainbox Groups",
  loginRedirect: "groups"
}
